import { APIRoute } from '@/modules/utils'
import { IRI } from 'emt-library'

export const Route = (disableIRI: IRI): APIRoute => ({
  method: 'DELETE',
  path: disableIRI,
})

export type Body = never
export type Response = never
